module.exports = __webpack_public_path__ + "static/media/martin_jicha.2ad5855b.jpg";